export enum OwnerBuyAccommodationDrawerMode {
  ACCOMMODATION,
  INTERNATIONAL_DESTINATION,
}
